import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type HeadDataService from 'frontend/services/head-data';

export default class NotFound extends Route {
  @service declare headData: HeadDataService;
  @service declare intl: IntlService;

  beforeModel() {
    this.headData.title = this.intl.t('title.404');
  }
}
